import React, { type ReactElement } from 'react';
import classnames from 'classnames';

import { CHART_DATA_THEMES } from './constant';
import SemiCircularChart, { type PlotPoint } from './SemiCircularChart';

import './RiskGraph.css';

export interface ChartScales {
  x_min: number;
  x_max: number;
  y_min: number;
  y_max: number;
}

export type ChartDataTheme =
  (typeof CHART_DATA_THEMES)[keyof typeof CHART_DATA_THEMES];

interface RiskGraphProps {
  plotPoints: PlotPoint[];
  centerCount: number;
  chartScales: ChartScales;
  isAnimation: boolean;
  isProcessing: boolean;
  filterCategories: string[];
  filterTooltips: string[];
  onPointClick: (point: PlotPoint) => void;
  isPointHoverDisabled: boolean;
  isSectorInteractive: boolean;
  dataTheme?: ChartDataTheme;
}

/**
 * RiskGraph
 */
function RiskGraph({
  plotPoints,
  centerCount,
  chartScales,
  isAnimation,
  isProcessing,
  filterCategories,
  filterTooltips,
  onPointClick,
  isPointHoverDisabled,
  isSectorInteractive,
  dataTheme = CHART_DATA_THEMES.DARK,
}: RiskGraphProps): ReactElement {
  const riskGraphClasses = classnames(
    'RiskGraph',
    dataTheme === CHART_DATA_THEMES.DARK && 'RiskGraph--isDark'
  );

  return (
    <div className={riskGraphClasses}>
      <div className='RiskGraph-wrapper'>
        <div className='RiskGraph-chartArea'>
          <SemiCircularChart
            plotPoints={plotPoints}
            centerCount={centerCount}
            chartScales={chartScales}
            isAnimation={isAnimation}
            isProcessing={isProcessing}
            filterCategories={filterCategories}
            filterPlacement={[]}
            filterTooltips={filterTooltips}
            isSectorInteractive={isSectorInteractive}
            onPointClick={onPointClick}
            isPointHoverDisabled={isPointHoverDisabled}
            xAxisTitle='Violation Age (Day)'
            yAxisTitle='Risk Score'
            xAxisLabelSpacing='tri'
            yAxisLabelSpacing='bi'
          />
        </div>
      </div>
    </div>
  );
}

RiskGraph.defaultProps = {
  dataTheme: CHART_DATA_THEMES.DARK,
};

export default RiskGraph;
